import { render, staticRenderFns } from "./AssetFavouriteBrowse.vue?vue&type=template&id=10dd9f0e&scoped=true"
import script from "./AssetFavouriteBrowse.vue?vue&type=script&lang=js"
export * from "./AssetFavouriteBrowse.vue?vue&type=script&lang=js"
import style0 from "./AssetFavouriteBrowse.vue?vue&type=style&index=0&id=10dd9f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dd9f0e",
  null
  
)

export default component.exports